import React from "react";

import DropdownComp from "../dropdown";

const addOrderHistory = (props) => {
  
    let disable = false
    if(props.orderStatus === "Completed"){
        disable = true
    }
    const {
        index,
        values,
        handleChange,
        setFieldValue,
        isSubmitting,
        products,
        touched,
        errors
    } = props;
    return (
        <div className="form-row">
            
            {/* {orderStatus !== "Completed" ?  */}
            <div className="form-group col-md-12">
                <label className="col-sm-5 pl-0 col-form-label">Order Status</label>

                <DropdownComp
                    className="col-sm-5 col-form-label"
                    id={`productAccess[${index}].productName`}
                    name={`productAccess[${index}].productName`}
                    onChange={(selectedValue) => {
                        setFieldValue(`productAccess[${index}].productName`, selectedValue);
                    }}
                    value={values.productAccess[index].productName}
                    options={products}
                    placeholder={props.orderStatus}
                    error={
                        touched.productAccess &&
                        errors.productAccess &&
                        errors.productAccess[index] &&
                        errors.productAccess[index].productName
                    }
                    errorText={
                        errors.productAccess &&
                        errors.productAccess[index] &&
                        errors.productAccess[index].productName
                    }
                    disabled={disable}
                />
            </div> 
            {/* : null} */}

            <div className="form-group col-md-12">
                <label className="col-sm-5 pl-0 col-form-label">Comment</label>
                <textarea
                    className="form-control" rows="5" 
                    id={`productAccess[${index}].quantity`}
                    name={`productAccess[${index}].quantity`}
                    placeholder="Comment"
                    type="textarea"
                    value={values.quantity}
                    onChange={handleChange}
                    error={
                        touched.productAccess &&
                        errors.productAccess &&
                        errors.productAccess[index] &&
                        errors.productAccess[index].quantity
                    }
                
                    disabled={isSubmitting} />
            </div>
        </div>
    );
};
export default addOrderHistory;
